<div class="modal" [ngClass]="{'show' :config?.showFindTrialCode}">

  <div class="modal-content">
    <div class="modal-content__body-container">
      <div class="modal-header">
        <h3 [translate]="'eos-tv-shop-ii.title.find-trial'" class="no-margin-buttom"></h3>
      </div>

      <p [translate]="'eos-tv-shop-ii.text.find-trial'"></p>
      <div class="column">
        <app-navigable-button
          [x]="0"
          [y]="0"
          [ownerComponent]="componentName"
          class="btn btn-grey"
          (emitOnEnterPressed)="openInputTrialCode()"
          (emitOnBack)="onBack()"
          [widthPercentage]="95">
          <span [translate]="'eos-tv-shop-ii.text.find-trial-enter-code'"></span>
        </app-navigable-button>
        <app-navigable-button
          [x]="0"
          [y]="1"
          [ownerComponent]="componentName"
          class="btn btn-grey"
          (emitOnEnterPressed)="onBack()"
          (emitOnBack)="onBack()"
          [widthPercentage]="95">
          <span [translate]="'eos-tv-shop-ii.btn.close'"></span>
        </app-navigable-button>
      </div>
    </div>
  </div>
</div>
